module.exports = __webpack_public_path__ + "img/co.2d3f2406.jpg";